module.exports = __webpack_public_path__ + "img/pic_rebate.4e248a87.svg";